import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { clearExpertiseReducer } from '../../../profile/actions/expertise';
import { FormFieldHelpers as Form } from '../../../../../../helpers/index';
import { validatePreferences as validate } from '../../../../../../helpers/SyncValidator';
import ThanksModal from '../../../../../common/elements/ThanksModal';
import ErrorModal from '../../../../../../components/common/elements/ErrorModal';
import Loader from '../../../../../common/elements/Loader';

class JobPreferencesForm extends Component {

    state = {
        countryChoice: null,
        isUpdated: false,
        isValidationError: false
    }

    componentWillMount() {
        this.handleInitialise();
    }

    componentWillReceiveProps(nextProps) {
        nextProps.profile.expertise.dataWithNames && nextProps.profile.expertise.dataWithNames !== null && this.setState({ isUpdated: true });
        if (nextProps.country !== undefined && this.props.country !== undefined && nextProps.country !== this.props.country) {
            this.props.resetLocation();
            this.props.resetPreferredLocation();
        }
    }

    sanitizeData(data) {
        let completeObject, formatted = [];
        data.map((elem) => {
            completeObject = {
                label: elem.name,
                value: elem.id,
            };
            formatted.push(completeObject)
        });
        return formatted;
    }

    sanitizeLocations(data) {
        let completeObject, formatted = [];
        data.map((elem) => {
            completeObject = {
                label: elem.name,
                value: elem.id,
            };
            formatted.push(completeObject)
        });
        return formatted;
    }

    handleInitialise() {
        const {
            profile,
            initialize } = this.props,
            { expertise,
                sectors,
                markets,
                industries,
                locations } = profile,
            { primary_industry } = industries,
            { primary_location, job_locations } = locations;

        const expertiseIds = expertise.expertise && this.sanitizeData(expertise.expertise),
            sectorsIds = sectors.sectors && this.sanitizeData(sectors.sectors),
            marketsIds = markets.markets && this.sanitizeData(markets.markets),
            industriesIds = industries.industries && this.sanitizeData(industries.industries),
            locationIds = job_locations.length && this.sanitizeLocations(job_locations);

        const initialValues = {
            "country_id": job_locations[0] ? { label: job_locations[0].country_name, value: job_locations[0].country_id } : '',
            "location_id": job_locations[0] ? locationIds : '',
            "preferred_location": primary_location && primary_location.id ? this.sanitizeData([primary_location]) : '',
            "expertise_id": expertiseIds,
            "industry_id": industriesIds,
            "preferred_industry": primary_industry && primary_industry.id ? this.sanitizeData([primary_industry]) : '',
            "market_id": marketsIds,
            "sector_id": sectorsIds,
        };
        initialize(initialValues);
    }

    handleRegionsList() {
        const { country } = this.props;
        const { countriesList } = this.props;
        const result = countriesList.filter(e => e.id === country.value);
        const regions = result[0].regions;
        return regions;
    }

    hideModal = (e) => {
        e.preventDefault();
        this.setState({ isUpdated: false });
        this.props.clearExpertiseReducer();
    }

    displayErrorModal = () => {
        this.setState({ isValidationError: true })
        return;
    }

    hideErrorModal = (e) => {
        e.preventDefault();
        this.setState({ isValidationError: false });
    }

    render() {
        const {
            countriesList,
            expertiseList,
            industriesList,
            marketsList,
            sectorsList,
            handleSubmit,
            country,
            profile,
            handleFormSubmit,
            handleCancel,
            message,
            submitFailed,
        } = this.props, { name } = profile;
    
    return (
            <div>
                {
                    this.state.isUpdated ?
                    <ThanksModal
                        message="Your preferences have been updated successfully"
                        onClose={this.hideModal}
                    />
                    : null
                }
                {
                    submitFailed ? 
                    <ErrorModal
                        message="Please complete all fields in the form."
                        isOpen={this.state.isValidationError}
                        onClose={this.hideErrorModal}
                    /> : null
                }
                <form className='row form-profile-location' onSubmit={handleSubmit(handleFormSubmit)}>
                    <div className="col-xs-12 col-centered legacy-input">
                        <br />
                        <h5 className="h5 user-message">{name.first} {name.last}, {message}</h5>
                        <fieldset>
                            <legend> Location</legend>
                            <div className="field-box">
                                <Field
                                    name="country_id"
                                    label="Country*"
                                    component={Form.selectField}
                                    placeholder="Select a country from the list"
                                    options={
                                        countriesList.map((selection) => {
                                            return {
                                                value: selection.id,
                                                label: selection.name,
                                            }
                                        })
                                    }
                                    clearable={true}
                                />
                            </div>
                            {country && <div className="field-box to-clear">
                                <Field
                                    name="preferred_location"
                                    label="Primary job search location*"
                                    component={Form.selectField}
                                    placeholder="Select primary location from the list"
                                    options={
                                        this.handleRegionsList(country.value).map(selected => {
                                            return {
                                                value: selected.id,
                                                label: selected.name
                                            }
                                        })
                                    }
                                    clearable={true}
                                />
                            </div>
                            }
                            {country && <div className="field-box to-clear">
                                <Field 
                                    name="location_id"
                                    label="Locations willing to travel to*"
                                    component={Form.selectField}
                                    placeholder="Select one or more job search locations from the list"
                                    options={
                                        this.handleRegionsList(country.value).map(selected => {
                                            return {
                                                value: selected.id,
                                                label: selected.name
                                            }
                                        })
                                    }
                                    clearable={true}
                                    multi={true}
                                    />
                            </div>
                            }
                        </fieldset>
                        <br />
                        <fieldset>
                            <legend>Market Indicators</legend>
                            <div className="field-box">
                                <Field
                                    name="preferred_industry"
                                    label="Main Industry*"
                                    placeholder="Select main industry from the list"
                                    component={Form.selectField}
                                    options={
                                        industriesList.map((selection) => {
                                            return {
                                                value: selection.id,
                                                label: selection.name,
                                            }
                                        })
                                    }
                                />
                            </div>
                            <div className="field-box">
                                <Field
                                    name="industry_id"
                                    label="Industries*"
                                    placeholder="Select one or more industries from the list"
                                    multi={true}
                                    component={Form.selectField}
                                    options={
                                        industriesList.map((selection) => {
                                            return {
                                                value: selection.id,
                                                label: selection.name,
                                            }
                                        })
                                    }
                                />
                            </div>
                            <div className="field-box">
                                <Field
                                    name="market_id"
                                    label="Markets*"
                                    placeholder="Select one or more markets from the list"
                                    multi={true}
                                    component={Form.selectField}
                                    options={
                                        marketsList.map((selection) => {
                                            return {
                                                value: selection.id,
                                                label: selection.name,
                                            }
                                        })
                                    }
                                />
                            </div>
                            <div className="field-box">
                                <Field
                                    name="expertise_id"
                                    label="Expertise*"
                                    component={Form.selectField}
                                    placeholder="Select one or more expertise from the list"
                                    multi={true}
                                    options={
                                        expertiseList.map((selection) => {
                                            return {
                                                value: selection.id,
                                                label: selection.name,
                                            }
                                        })
                                    }
                                />
                            </div>

                            <div className="field-box">
                                <Field
                                    name="sector_id"
                                    label="Sectors*"
                                    placeholder="Select one or more sectors from the list"
                                    component={Form.selectField}
                                    options={
                                        sectorsList.map((selection) => {
                                            return {
                                                value: selection.id,
                                                label: selection.name,
                                            }
                                        })
                                    }
                                    multi={true}
                                />
                            </div>
                        </fieldset>
                    </div>
                    <br />
                    {!this.props.profile.expertise.request &&
                        <ul className="buttons-center">
                            <li>
                                <button type="button" className="btn btn-warning" onClick={() => handleCancel()}>
                                    <span className="label">Cancel</span>
                                    <span className="icon"><i className="fa fa-times" /></span>
                                </button>
                            </li>
                            <li>
                                <button type="submit" className="btn btn-primary" onClick={ () => this.displayErrorModal()}>
                                    <span className="label">Save</span>
                                    <span className="icon"><i className="fa fa-pencil" /></span>
                                </button>
                            </li>
                        </ul>
                    }
                    <br />
                </form>
                {this.props.profile.expertise.request && <Loader />}
                
            </div>
        )
    }
}

JobPreferencesForm = reduxForm({ form: "second-step-registration", validate })(JobPreferencesForm);

const selector = formValueSelector('second-step-registration');

const mapStateToProps = (state) => {
    return {
        country: selector(state, 'country_id'),
        preferred_location: selector(state, 'preferred_location'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetLocation: () => dispatch(change('second-step-registration', 'location_id', '')),
        resetPreferredLocation: () => dispatch(change('second-step-registration', 'preferred_location', '')),
        clearExpertiseReducer: () => dispatch(clearExpertiseReducer()),
    };
};


JobPreferencesForm.propTypes = {
    profile: PropTypes.object,
    countriesList: PropTypes.array,
    industriesList: PropTypes.array,
    marketsList: PropTypes.array,
    sectorsList: PropTypes.array,
    history: PropTypes.object,
    clearJobLocations: PropTypes.func,
    handleFormSubmit: PropTypes.func,
    handleCancel: PropTypes.func,
    resetLocation: PropTypes.func,
    resetPreferredLocation: PropTypes.func,
    message: PropTypes.string,
    country: PropTypes.object,
    preferred_location: PropTypes.array
}

export default connect(mapStateToProps, mapDispatchToProps)(JobPreferencesForm);


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobPreferencesForm.js